import { FormItem, Input as FaveInput, InputProps } from 'fave-ui';
import styles from './style.module.css';
import { getIn, useFormikContext } from 'formik';
import { cn } from '../../../helpers/cn';
import { useEffect } from 'react';

type Props<T> = {
  name: keyof T;
  label: string;
} & InputProps;

const InputText = <T extends {}>({
  name,
  label,
  className,
  ...restProps
}: Props<T>) => {
  const {
    errors,
    touched,
    handleBlur,
    values,
    setFieldValue,
    setFieldTouched,
  } = useFormikContext<T>();

  const isArrayField = name.includes('.');

  const innerValue = isArrayField ? getIn(values, name) : values[name];
  const error = isArrayField ? getIn(errors, name) : errors[name];
  const isTouched = isArrayField ? getIn(touched, name) : touched[name];
  const helpText = isTouched && error !== undefined && error;

  // trigger validate on change
  // does not work when implemented inside handleOnChange
  useEffect(() => {
    if (innerValue || innerValue === '') setFieldTouched(name, true, true);
  }, [innerValue]);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setFieldValue(name, value);
  };

  const handleOnBlur = () => {
    handleBlur(name);
    setFieldTouched(name, true, true);
  };

  return (
    <FormItem
      className={styles.formItem}
      label={label}
      validateStatus={error !== undefined && isTouched ? 'error' : 'success'}
      help={helpText}
      rules={[{ required: true }]}
    >
      <FaveInput
        {...restProps}
        value={innerValue}
        className={cn(className, styles.inputNumber)}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
      />
    </FormItem>
  );
};

export default InputText;
